import React from 'react';
import './styles.css';


const HeaderText = (props) => {


    return (
        <div style={props.customStyleHeaderText} className="header-text">{props.headerText}</div>
    )


};

export default HeaderText;



// WEBPACK FOOTER //
// ./src/components/HeaderText/HeaderText.js